import React from 'react'
import MediaQueryWrapper from './MediaQueryWrapper'
import { minWidthMd, minWidthLg } from 'shared/breakpoints'

const TabletView = (props) => {
  const newProps = { ...props, minWidth: minWidthMd, maxWidth: minWidthLg - 1 }

  return <MediaQueryWrapper {...newProps} />
}

export default TabletView
